import { Route } from 'vue-router'

export default function(to: Route) {
    if (window.$crisp) {
        if (to.meta.allowCrisp) {
            window.$crisp.push(['do', 'chat:show'])
        } else {
            window.$crisp.push(['do', 'chat:close'])
            window.$crisp.push(['do', 'chat:hide'])
        }
    }
}
